var map = {
	"./echat-logo-text.svg": 3319,
	"./echat-logo.svg": 2677,
	"./messengers/telegram_btn.svg": 7307,
	"./messengers/tiktok_btn.svg": 748,
	"./messengers/viber_btn.svg": 2658,
	"./messengers/viber_telephony.svg": 9538,
	"./messengers/whatsapp_btn.svg": 6312,
	"./search-alt-svgrepo-com.svg": 9459,
	"./search.svg": 200,
	"./telegram.svg": 549,
	"./tiktok.svg": 18,
	"./viber.svg": 2202,
	"./whatsapp.svg": 7606
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12;